import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "./../components/Layout";

import Countdown from "react-countdown";
import Sponsors from "../components/Sponsors";
import Map from "../components/Map";

const Home = () => {
  return (
    <Layout>
      <section className="slider-area">
        <div className="slider-active">
          <div className="single-slider  slider-height hero-overly slider-bg1 d-flex align-items-center">
            <div className="container position-relative">
              <div className="row">
                <div className="col-xxl-5 col-xl-7 col-lg-6 col-md-8 col-sm-10">
                  <div className="hero-caption">
                    <h1 data-animation="pulse" data-delay=".2s">
                      <span>ATOMOS</span> Habib University’s science
                    </h1>

                    <div className="video-icon">
                      <a className="popup-video btn-icon" href="#">
                        <i className="fas fa-play"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="hero-footer">
                <h4>Coming Soon</h4>
                <p>Habib University, Karachi, Pakistan.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="count-down-area top-padding">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="section-tittle mb-40">
                <h2>
                  About <br />
                  The Event
                </h2>
                <Link to="/register" className="btn_1 mt-20">
                  Register Now<i className="ti-arrow-right"></i>
                </Link>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7 col-md-12">
              <div className="section-tittle mb-40">
                <p>
                  Habib University's esteemed flagship Science Olympiad and
                  Hackathon, returning with an innovative twist. This event
                  transcends boundaries, embracing diverse subjects beyond
                  science and programming. ATOMOS features modules spanning
                  Natural Sciences, Mathematics, Arts, Logic, Engineering,
                  Programming, Gaming, and Hackathon domains.
                </p>
                <p>
                  Scheduled from January 3rd to 5th, 2024, this three-day event
                  offers unparalleled cross-disciplinary exploration, fostering
                  intellectual growth and collaboration. With its unique blend
                  of academic and creative domains, ATOMOS is not merely a
                  competition but a convergence of innovation, where
                  participants unlock new dimensions of learning.
                </p>
              </div>

              <div className="count-down-wrapper">
                <div className="row justify-content-between">
                  <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4">
                    <div className="single mb-30">
                      <div className="single-counter">
                        <p>0</p>
                        <span className="counter">3</span>
                      </div>
                      <div className="pera-count">
                        <p>Day Event</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4">
                    <div className="single mb-30">
                      <div className="single-counter">
                        <span className="counter">20</span>
                        <p className="">+</p>
                      </div>
                      <div className="pera-count">
                        <p>Modules</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4">
                    <div className="single mb-30">
                      <div className="single-counter">
                        <span className="counter">0</span>
                        <p className="">+</p>
                      </div>
                      <div className="pera-count">
                        <p>Sponsors</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <br />
      <br />
      <br />
      <br />
      <section className="about-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-7 col-xl-7 col-lg-6 col-md-8">
              <div className="about-img">
                <img
                  src="./img/gallery/xabout1.jpg.pagespeed.ic.F07jdrxUzO.webp"
                  alt=""
                />
              </div>
            </div>
            <div className="offset-xxl-1 col-xxl-4 col-xl-5 col-lg-6 col-md-9">
              <div className="about-caption">
                <div className="section-tittle mb-25">
                  <h2>
                    Our University
                    <span>& CSEC</span>
                  </h2>
                  <p>
                    Habib University is a Liberal Arts and Science University
                    that offers an interdisciplinary education drawing from the
                    fields of Science, Engineering, Arts, Humanities, and Social
                    Sciences. It is committed to providing the highest standards
                    of excellence in Education. Computer Science and Engineering
                    Club (CSEC) Is Habib University's leading student-led club
                    providing students with a platform to become potent
                    contributors to Pakistan's Science and Research output by
                    harmonizing scientific research within the university,
                    facilitating the student body in their research,
                    streamlining and synchronizing research content and
                    facilities by disambiguation and reduction of the divide
                    between different branches of science.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="shedule-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-6 col-md-6">
              <div className="section-tittle mb-30">
                <h2>Schedule</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="nav-button">
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <a
                      className="nav-link active"
                      id="nav-one-tab"
                      data-bs-toggle="tab"
                      href="#nav-one"
                      role="tab"
                      aria-controls="nav-one"
                      aria-selected="true"
                    >
                      3rd Jan
                    </a>
                    <a
                      className="nav-link"
                      id="nav-two-tab"
                      data-bs-toggle="tab"
                      href="#nav-two"
                      role="tab"
                      aria-controls="nav-two"
                      aria-selected="false"
                    >
                      4th Jan
                    </a>
                    <a
                      className="nav-link"
                      id="nav-three-tab"
                      data-bs-toggle="tab"
                      href="#nav-three"
                      role="tab"
                      aria-controls="nav-three"
                      aria-selected="false"
                    >
                      5th Jan
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="nav-one"
              role="tabpanel"
              aria-labelledby="nav-one-tab"
            >
              <div className="row justify-content-center">
                <div className="col-lg-11">
                  <div className="shedule-wrapper">
                    {/* <div className="single-items">
                      <div className="shedule-items">
                        <div className="shedule-left">
                          <div className="job-tittle">
                            <a href="https://preview.colorlib.com/theme/eventotemplate/job_details.html">
                              <h4>Registration And Breakfast</h4>
                            </a>
                            <p>- Mal Practice</p>
                          </div>
                        </div>
                        <div className="price">
                          <span>8:30 am</span>
                        </div>
                      </div>
                    </div> */}
                    <div className="single-items">
                      <div className="shedule-items">
                        <div className="shedule-left">
                          <div className="job-tittle">
                            <h4 style={{ color: "white" }}>
                              Will be shared soon.
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-two"
              role="tabpanel"
              aria-labelledby="nav-two-tab"
            >
              <div className="row justify-content-center">
                <div className="col-lg-11">
                  <div className="shedule-wrapper">
                    <div className="single-items">
                      <div className="shedule-items">
                        <div className="shedule-left">
                          <div className="job-tittle">
                            <h4 style={{ color: "white" }}>
                              Will be shared soon.
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-three"
              role="tabpanel"
              aria-labelledby="nav-three-tab"
            >
              <div className="row justify-content-center">
                <div className="col-lg-11">
                  <div className="shedule-wrapper">
                    <div className="single-items">
                      <div className="shedule-items">
                        <div className="shedule-left">
                          <div className="job-tittle">
                            <h4 style={{ color: "white" }}>
                              Will be shared soon.
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Map />
    </Layout>
  );
};

export default Home;
